import { createUseStyles } from 'react-jss';
import {
  BackgroundColors,
  TextColors,
  PrimaryColors,
} from '@picsart/design-system/foundation/colors';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { FontSizes } from '@picsart/design-system/foundation/typography';
import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { Easings } from '@picsart/design-system/foundation/easings';

const useStyles = createUseStyles(
  {
    '@keyframes fadeIn': {
      from: { opacity: 0, transform: 'translateY(10px)' },
      to: { opacity: 1, transform: 'translateY(0)' },
    },
    '@keyframes logoGlow': {
      '0%, 100%': {
        filter: `drop-shadow(0 0 8px ${PrimaryColors.alpha?.alpha50})`,
        transform: 'scale(1)',
      },
      '50%': {
        filter: `drop-shadow(0 0 20px ${PrimaryColors.alpha?.alpha80})`,
        transform: 'scale(1.02)',
      },
    },
    '@keyframes dotPulse': {
      '0%, 80%, 100%': {
        opacity: 0.3,
        transform: 'scale(0.8)',
      },
      '40%': {
        opacity: 1,
        transform: 'scale(1)',
      },
    },
    container: {
      position: 'fixed',
      inset: 0,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: Spacings.s24,
      backgroundColor: BackgroundColors.base,
    },
    logo: {
      // 64×64 logo size — raw px (sizing, not spacing)
      width: 64,
      height: 64,
      animation: `$fadeIn 0.5s ${Easings.easeOut}, $logoGlow 2.5s ${Easings.easeInOut} infinite`,
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: Spacings.s16,
      animation: `$fadeIn 0.5s ${Easings.easeOut} 0.15s both`,
    },
    title: {
      fontSize: FontSizes.t6,
      fontWeight: FontWeights.semibold,
      background: `linear-gradient(135deg, ${PrimaryColors.base.default} 0%, ${PrimaryColors.base.action} 100%)`,
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text',
    },
    dots: {
      display: 'flex',
      gap: Spacings.s6,
    },
    dot: {
      width: Spacings.s8,
      height: Spacings.s8,
      borderRadius: CornerRadius.circle,
      backgroundColor: TextColors.tint2,
      animation: `$dotPulse 1.4s ${Easings.easeInOut} infinite`,
      '&:nth-child(1)': { animationDelay: '0s' },
      '&:nth-child(2)': { animationDelay: '0.2s' },
      '&:nth-child(3)': { animationDelay: '0.4s' },
    },
  },
  { name: 'app-loader' }
);

export default useStyles;
